import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// 상점 업무처리
class StoreWorkProcessApi extends Requestor {
    /**
     * 리스트 조회
     */
    getItemList(params = {}) {
        return this.get({
            url: '/api/v2/store-notices',
            params,
        });
    }
    /**
     * 단건 조회
     */
    getItem(id, params) {
        return this.get({
            url: `/api/v2/store-notices/${id}`,
            params,
        });
    }
    /**
     * 단건 삭제
     */
    // eslint-disable-next-line class-methods-use-this
    deleteItem(id) {
        return this.delete({
            url: `/api/v2/store-notices/${id}`,
        });
    }
    /**
     * 단건 수정
     */
    // eslint-disable-next-line class-methods-use-this
    putItem(id, data) {
        return this.put({
            url: `/api/v2/store-notices/${id}`,
            data,
        });
    }
    /**
     * 단건 등록
     */
    postItem(data) {
        return this.post({
            url: '/api/v2/store-notices',
            data,
        });
    }
    /**
     * 답변 등록
     */
    postReply(data) {
        return this.post({
            url: '/api/v2/store-notices/comment',
            data,
        });
    }
}
export const storeWorkProcessApi = new StoreWorkProcessApi(clientInstance);
